const Taxonomies = {
  ACCESSORY: "accessory",
  CLOTHING: "clothing",
  DRESS: "dress",
  KIDS: "kids",
  HOMEGOOD: "homegood",
  RENTABLE: "rentable",
};
Taxonomies.RENTAL_ONLY = [Taxonomies.RENTABLE, Taxonomies.KIDS, Taxonomies.HOMEGOOD];

// This is similar to how the ruby code functions, searching the product categories mappings
// up the tree to see the item's root category (ex: Trousers -> Pants -> Bottoms -> Clothing -> Rentable)
export function isRentableProductCategory(id, productCategories = []) {
  if (!id) return false;
  if (!productCategories) return false;

  if (Taxonomies.RENTAL_ONLY.includes(id)) return true;

  const parentId = productCategories.find?.(productCategory => productCategory.id === id)?.parent?.id;

  return isRentableProductCategory(parentId, productCategories);
}

export const isAccessoryProductCategory = fnProductCategoryMatch(Taxonomies.ACCESSORY);

export const isClothingProductCategory = fnProductCategoryMatch(Taxonomies.CLOTHING);

export const isDressProductCategory = fnProductCategoryMatch(Taxonomies.DRESS);

export const isHomegoodProductCategory = fnProductCategoryMatch(Taxonomies.HOMEGOOD);

export const isBackupSizeCategory = (id, categories) => {
  return (
    isClothingProductCategory(id, categories) ||
    isDressProductCategory(id, categories) ||
    isKidsProductCategory(id, categories)
  );
};

const isKidsProductCategory = fnProductCategoryMatch(Taxonomies.KIDS);

function fnProductCategoryMatch(taxonomy) {
  return (id, productCategories = []) => {
    if (!id) return false;
    if (!productCategories) return false;

    if (id === taxonomy) return true;

    const parentId = productCategories.find?.(productCategory => productCategory.id === id)?.parent?.id;

    return fnProductCategoryMatch(taxonomy)(parentId, productCategories);
  };
}
